
    import Vue from "vue";

    const END_POINT = "/account/contact-type";

    const getContactType = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllContactTypes = data => Vue.axios.post(END_POINT+ "/search", data);

    const createContactType = contactType => Vue.axios.post(END_POINT,  contactType );

    const updateContactType = contactType => Vue.axios.put(END_POINT  + "/" + contactType.id,  contactType );

    const deleteContactType = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getContactType,
      getAllContactTypes,
      createContactType,
      updateContactType,
      deleteContactType
    };
    